import {PULLS_INBOX_PATH, PULLS_PATH} from '../constants/routes'

export const isOnInboxPath = ({pathname}: {pathname: string}) => {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  return normalized === PULLS_PATH || normalized === PULLS_INBOX_PATH
}
